module.exports = __webpack_public_path__ + "static/media/my-payment-methods.1b9d3e8c.svg";